var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$store.state.displayType === "textual"
    ? _c("default-textual-section", {
        staticClass: "menu--section-bimini",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "section-modifier": _vm.sectionModifier,
          "menu-item-component": _vm.menuItemComponent,
          "content-area-top-layout":
            "bimini-steak-item" === _vm.menuItemComponent ? "above-title" : "",
          "content-area-bottom-layout":
            "bimini-steak-item" === _vm.menuItemComponent ? "none" : "",
          "is-tag-legend-hidden": "bimini-steak-item" === _vm.menuItemComponent,
          "is-title-buffer-visible": _vm.isTitleBufferVisible,
        },
      })
    : _c("default-visual-section", {
        staticClass: "menu--section-bimini",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "section-modifier": _vm.sectionModifier,
          "menu-item-component": _vm.menuItemComponent,
          "content-area-top-layout":
            "bimini-steak-item" === _vm.menuItemComponent ? "above-title" : "",
          "content-area-bottom-layout":
            "bimini-steak-item" === _vm.menuItemComponent ? "none" : "",
          "is-tag-legend-hidden": "bimini-steak-item" === _vm.menuItemComponent,
          "is-title-buffer-visible": _vm.isTitleBufferVisible,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }